import React from 'react';
// import 'views/Admin/Dashboard/styles.css';

type Props = {
  id: string;
  os: string;
  maxCharLength?: number;
};

const OSInfo = ({ id, os, maxCharLength = 30 }: Props) => {
  // Convert the OS string to lowercase once for efficiency
  const osLower = os.toLowerCase();

  // Determine the appropriate icon by checking for more specific substrings first.
  // Specific Linux distributions are checked before the generic "linux" keyword.
  let icon = 'desktop'; // Default icon

  if (osLower.includes('ubuntu')) {
    icon = 'ubuntu';
  } else if (osLower.includes('fedora')) {
    icon = 'fedora';
  } else if (osLower.includes('debian')) {
    icon = 'debian';
  } else if (osLower.includes('android')) {
    icon = 'android';
  } else if (osLower.includes('chrome')) {
    // This covers Chrome OS or Chrome browser indication
    icon = 'chrome';
  } else if (osLower.includes('windows')) {
    icon = 'windows';
  } else if (osLower.includes('mac') || osLower.includes('ios')) {
    // macOS and iOS both map to the Apple icon
    icon = 'apple';
  } else if (osLower.includes('centos')) {
    icon = 'centos';
  } else if (osLower.includes('linux')) {
    // Generic Linux fallback if no specific distribution is mentioned
    icon = 'linux';
  } else if (osLower.includes('unix') || osLower.includes('bsd')) {
    // Generic Unix/BSD fallback using the terminal icon
    icon = 'terminal';
  } else if (osLower.includes('solaris')) {
    icon = 'sun';
  }

  // Define the icons that are available as brand icons.
  // Specific OS icons such as ubuntu, fedora, debian, windows, apple, android, chrome, and generic linux are brands.
  const brandIcons = [
    'windows',
    'apple',
    'linux',
    'android',
    'chrome',
    'ubuntu',
    'fedora',
    'debian',
    'centos',
  ];

  // Select the correct style prefix:
  // - 'fa-brands' for brand icons.
  // - 'fa-solid' for icons rendered in the solid style (like 'desktop', 'terminal', 'sun').
  const prefix = brandIcons.includes(icon) ? 'fa-brands' : 'fa-solid';

  return (
    <div id={id} className="d-inline">
      {/* Container for icon and OS name */}
      <div className="d-flex justify-content-space-between align-items-center">
        {/* Icon element with dynamically determined prefix and icon name.
            It uses 'fa-2xl' for sizing and 'text-primary' for color. */}
        <i className={`text-primary ${prefix} fa-${icon} fa-2xl`} />
        {/* Display the OS string; truncate if longer than 25 characters */}
        <span
          className="ml-2"
          style={{ textDecoration: 'underline', textDecorationStyle: 'dotted' }}
        >
          {os.length > maxCharLength ? os.slice(0, maxCharLength) + '...' : os}
        </span>
      </div>
    </div>
  );
};

export default OSInfo;
